/***********************/
/* Angular + external */
import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  forwardRef,
  SimpleChanges,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

/***********************/
/* BFX */
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { throwIfEmpty } from "rxjs/operators";
// models

export const EXECUTION_MODE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ICExecutionModeComponent),
  multi: true,
};

@Component({
  selector: "ic-execution-mode",
  templateUrl: "./html/ic-execution-mode.html",
  providers: [EXECUTION_MODE_VALUE_ACCESSOR],
  standalone: false,
})
export class ICExecutionModeComponent
  implements OnInit, OnDestroy, OnChanges, ControlValueAccessor
{
  /**********************************************************************/
  /* INPUT */

  @Input() inputId: string;

  @Input("loading") input_isLoading: boolean = false;

  @Input("client") input_client: any;

  @Input("label") input_label: any = "Auto Execute";

  public onModelChange: Function = (value: any) => {};
  public onModelTouched: Function = () => {};

  /**********************************************************************/
  /* DATA */

  public data: any = {
    label: "Auto Execute",
    enabled: false,
    value: CubiqTS.ExecutionType.MANUAL, // ExecutionType enum
    valueBoolean: false,
    locked: false,
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */

  constructor() {}

  /**********************************************************************/
  /* LIFE CYCLE HOOKS */
  ngOnInit() {
    this.onConstraintChanges();
  }

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === "input_label") {
        this.data.label = this.input_label;
      } else if (propName !== "input_isLoading" && propName !== "inputId") {
        this.onConstraintChanges();
      }
    }
  }

  /**********************************************************************/
  /* INITIALIZATION */
  public initialize(): void {
    this.data.label = this.input_label;
    this.onConstraintChanges();
  }

  /**********************************************************************/
  /* ControlValueAccessor */

  public writeValue(value: any): void {
    this.data.value = value;
    this.onModelChange(this.data.value);
  }

  public registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  public registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  /**********************************************************************/
  /* BASIC - API */

  public load(value: CubiqTS.ExecutionType): void {
    if (value === CubiqTS.ExecutionType.AUTOMATIC || value === CubiqTS.ExecutionType.MANUAL) {
      this.data.valueBoolean = value === CubiqTS.ExecutionType.AUTOMATIC;
      this.data.value = value;
    } else {
      logger.out.error(`ERROR: icExecutionMode.load(): failed to load '${value}'`);
    }
  }

  public reset(): void {
    this.data.enabled = false;
    this.data.value = CubiqTS.ExecutionType.MANUAL;
    this.data.valueBoolean = false;
    this.data.locked = false;
  }

  public lock(): void {
    this.data.locked = true;
  }

  public unlock(): void {
    this.data.locked = false;
  }

  public conditionalEnable(): void {
    if (this.input_client instanceof CubiqTS.ClientImpl && !this.input_client.autoFillEnabled) {
      this.disable();
    } else {
      this.enable();
    }
  }

  private enable(): void {
    this.data.enabled = true;
  }

  public disable(): void {
    this.data.enabled = false;
  }
  /**********************************************************************/
  /* ON CHANGES */

  public onConstraintChanges(): void {
    if (this.input_client == null || !(this.input_client instanceof CubiqTS.ClientImpl)) {
      this.data.enabled = true;
    } else if (!this.input_client.autoFillEnabled) {
      //  && this.data.meta.prevClient == null
      this.data.valueBoolean = false;
      this.data.enabled = false;
    } else if (this.input_client.autoFillEnabled) {
      //&& this.data.meta.prevClient == null
      if (!this.input_isLoading) this.data.valueBoolean = true;
      this.data.enabled = true;
    }
    this.onValueChange();
  }

  public onValueChange(): void {
    this.data.value = this.data.valueBoolean
      ? CubiqTS.ExecutionType.AUTOMATIC
      : CubiqTS.ExecutionType.MANUAL;
    this.writeValue(this.data.value);
  }
}
